export const recommendedActions = ['maproulette', 'map', 'streetcomplete', 'mapillary'] as const
